<section class="showcase" [attr.aria-label]="lang.t('homeWelcome1')">
  <p class="welcome"><span>{{ lang.t('homeWelcome1') }}</span><span>{{ lang.t('homeWelcome2') }}</span><em>{{ lang.t('homeWelcome3') }}</em></p>
  <div class="showcase-copy">
    <h1>{{ lang.t('homeH1') }} <em>{{ lang.t('homeH1em') }}</em></h1>
    <p class="lede">{{ lang.t('homeLede') }}</p>
    <div class="hero-actions">
      @if (auth.signedIn()) {
        <a class="btn trade" routerLink="/markets">{{ lang.t('homeTrade') }}</a>
        <a class="btn ghost light" routerLink="/portfolio">{{ lang.t('homeDeposit') }}</a>
      } @else {
        <a class="btn trade" routerLink="/signup">{{ lang.t('homeTrade') }}</a>
        <a class="btn ghost light" routerLink="/signin">{{ lang.t('homeDeposit') }}</a>
      }
    </div>
    <p class="fine">{{ lang.t('homeLicensed') }}</p>
  </div>

  <div class="showcase-stage">
    <img class="shot shot-crypto" src="liiji-crypto-desk.jpg" [alt]="lang.t('homeAltScreen')" />
    <img class="shot shot-b" src="liiji-trader-2.jpg" [alt]="lang.t('homeAltTrader')" />

    @if (card('BTC-USD'); as quote) {
      <a class="float-card at-btc" [routerLink]="['/trade', quote.symbol]">
        <span class="mark btc" aria-hidden="true">₿</span>
        <span>
          <strong>Bitcoin</strong>
          <em>{{ price(quote.price, quote.precision) }} <b [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</b></em>
        </span>
      </a>
    }
    @if (card('NVDA'); as quote) {
      <a class="float-card at-nvda" [routerLink]="['/trade', quote.symbol]">
        <span class="mark nvda" aria-hidden="true">N</span>
        <span>
          <strong>NVIDIA <small>NVDA</small></strong>
          <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</em>
        </span>
        <app-sparkline [points]="quote.spark" [up]="quote.changePct >= 0" [width]="72" [height]="28" />
      </a>
    }
    @if (card('META'); as quote) {
      <a class="float-card at-meta" [routerLink]="['/trade', quote.symbol]">
        <span class="mark meta" aria-hidden="true">∞</span>
        <span>
          <strong>Meta</strong>
          <em>{{ price(quote.price, quote.precision) }} <b [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</b></em>
        </span>
      </a>
    }
  </div>
  <svg class="showcase-wave" viewBox="0 0 1440 120" preserveAspectRatio="none" aria-hidden="true">
    <path d="M0 70 C 180 110, 320 20, 520 48 S 860 120, 1080 64 S 1320 20, 1440 56 L 1440 120 L 0 120 Z" />
  </svg>
</section>

<div class="home-body">
<section class="hero" id="company">
  <div class="hero-copy">
    <h2>{{ lang.t('homeEdge') }}</h2>
    <p class="lede">{{ lang.t('homeP1') }}</p>
    <p class="lede">{{ lang.t('homeP2') }}</p>
    <p class="kicker">{{ lang.t('homeWhy') }}</p>
    <ul class="edge-list">
      <li><strong>{{ lang.t('homeSpeed') }} :</strong> {{ lang.t('homeSpeedBody') }}</li>
      <li><strong>{{ lang.t('homeSecurity') }}: </strong> {{ lang.t('homeSecurityBody') }}</li>
      <li><strong>{{ lang.t('homeReliable') }}: </strong> {{ lang.t('homeReliableBody') }}</li>
    </ul>
    <p class="lede">{{ lang.t('homeRegister') }}</p>
  </div>

  <aside class="desk" aria-label="Live quotes">
    <figure class="still">
      <img src="liiji-ai-still1.jpg" alt="An evening table: a cream page, a gold pen, and a black screen with one gold line." />
    </figure>
    <figure class="reel" aria-label="Looping film. A gold line draws itself, then the sentence appears.">
      <div class="reel-screen">
        <svg viewBox="0 0 640 360" role="img">
          <rect width="640" height="360" fill="#121310" />
          <g class="drift" fill="#9a9488" font-family="IBM Plex Mono, ui-monospace, monospace" font-size="14">
            <text x="28" y="46">NVDA  187.40</text>
            <text x="196" y="46">AAPL  228.15</text>
            <text x="364" y="46">BTC   67,420</text>
            <text x="532" y="46">XAU   2,684</text>
            <text x="700" y="46">SPY   572.10</text>
          </g>
          <path class="trace" d="M36 228 C 120 214, 170 206, 230 196 S 340 168, 400 124 S 520 188, 604 236" />
          <text class="line-in" x="36" y="312" fill="#e4c99a" font-family="Fraunces, Georgia, serif" font-size="32" font-style="italic">{{ lang.t('homeQuiet') }}</text>
        </svg>
      </div>
      <figcaption>
        <span class="playing"><i></i> {{ lang.t('homePlaying') }}</span>
        <span>{{ lang.t('homeFilm') }}</span>
      </figcaption>
    </figure>
    <div class="desk-top">
      <span>{{ lang.t('homeMorning') }}</span>
      <span class="live"><i></i> {{ lang.t('homeLive') }}</span>
    </div>
    @if (desk().length === 0) {
      <div class="desk-empty">
        @if (market.offline()) {
          <p>{{ lang.t('homeOffline') }}</p>
        } @else {
          <p>{{ lang.t('homeOpening') }}</p>
        }
      </div>
    } @else {
      <ul class="desk-list">
        @for (quote of desk(); track quote.symbol) {
          <li>
            <a [routerLink]="['/trade', quote.symbol]">
              <span>
                <strong>{{ quote.symbol }}</strong>
                <em>{{ quote.name }}</em>
              </span>
              <app-sparkline [points]="quote.spark" [up]="quote.changePct >= 0" [onDark]="true" />
              <span class="desk-px">
                <strong>{{ price(quote.price, quote.precision) }}</strong>
                <em [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</em>
              </span>
            </a>
          </li>
        }
      </ul>
    }
    <a class="desk-foot" routerLink="/trade/NVDA">{{ lang.t('homeTradeNvda') }} <span aria-hidden="true">→</span></a>
  </aside>
</section>

<section class="ai" id="platform" aria-labelledby="ai-heading">
  <div class="ai-quote">
    <p class="kicker light">{{ lang.t('homeDepKicker') }}</p>
    <h2 id="ai-heading">{{ lang.t('homeDepH') }} <em>{{ lang.t('homeDepEm') }}</em></h2>
<p class="ai-phrase">{{ lang.t('homeDepP') }}</p>

<h3>{{ lang.t('homeHow') }}</h3>
<ol class="ai-steps">
  <li><strong>{{ lang.t('homeLi1') }}</strong> {{ lang.t('homeLi1b') }}</li>
  <li><strong>{{ lang.t('homeLi2') }}</strong> {{ lang.t('homeLi2b') }}</li>
  <li><strong>{{ lang.t('homeLi3') }}</strong> {{ lang.t('homeLi3b') }}</li>
  <li><strong>{{ lang.t('homeLi4') }}</strong>{{ lang.t('homeLi4b') }}</li>
</ol>

<p class="ai-disclaimer">
  <small>{{ lang.t('homeFine') }}</small>
</p>
    <figure class="still still-wide">
      <img src="AI-crypto-bot11.webp" alt="An AI figure at a crypto trading screen." />
    </figure>
  </div>
  <div class="ai-card">
    <div class="support">
      <div>
        <h2 id="support-heading">{{ lang.t('homeSupport') }}</h2>
        <ul class="support-list">
          <li>
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.2 6.2 11.4 13 4.6" /></svg>
            {{ lang.t('homeGlobal') }}
          </li>
          <li>
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.2 6.2 11.4 13 4.6" /></svg>
            {{ lang.t('homeAssist') }}
          </li>
          <li>
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.2 6.2 11.4 13 4.6" /></svg>
            {{ lang.t('homeAccess') }}
          </li>
          <li>
            <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8.2 6.2 11.4 13 4.6" /></svg>
            {{ lang.t('homeMulti') }}
          </li>
        </ul>
      </div>
      <div class="support-map" aria-hidden="true">
        <svg viewBox="0 0 640 320">
          <path d="M168 36c10-8 24-6 28 4 3 8-4 16-14 18s-18-6-18-14c0-4 1-6 4-8z" />
          <path d="M52 92l22-24 34-14 38-4 28 14 18 22 4 18-12 12 8 16-10 14-16 10-8 18-20 4-18-12-14-16-12-8-16-20-10-18z" />
          <path d="M132 186l22-8 24 10 12 22 4 28-8 26-18 16-22-6-16-22-8-28 2-22z" />
          <path d="M268 70l22-12 28 4 14 16-4 16-18 12-24 2-16-12z" />
          <path d="M258 112l34-8 36 10 18 28 6 36-8 32-22 22-28 4-24-18-16-32-6-36z" />
          <path d="M328 64l48-16 70 4 62 16 36 22-6 22-34 10-48-4-42 12-40-6-28-16-16-22z" />
          <path d="M478 188l32-8 28 10 6 18-12 16-28 6-24-12-8-16z" />
        </svg>
        <span class="pin pin-a" style="left:18%;top:28%">A</span>
        <span class="pin pin-b" style="left:16%;top:46%">M</span>
        <span class="pin pin-c" style="left:26%;top:72%">L</span>
        <span class="pin pin-d" style="left:46%;top:26%">S</span>
        <span class="pin pin-e" style="left:46%;top:52%">K</span>
        <span class="pin pin-f" style="left:62%;top:36%">R</span>
        <span class="pin pin-g" style="left:78%;top:24%">J</span>
        <span class="pin pin-h" style="left:80%;top:66%">N</span>
      </div>
    </div>
    @if (brief(); as brief) {
      <p class="kicker">{{ lang.t('homeLiveRead') }}</p>
      <p class="ai-line">
        @switch (lens()) {
          @case ('focus') {
            {{ lang.t('homeFocusA') }} <strong>{{ brief.leader.symbol }}</strong> {{ lang.t('homeFocusB') }}
            <span [class.up]="brief.leader.changePct >= 0" [class.down]="brief.leader.changePct < 0">{{ pct(brief.leader.changePct) }}</span>.
          }
          @case ('pace') {
            {{ brief.rising }} {{ lang.t('homePaceOf') }} {{ brief.total }} {{ lang.t('homePaceA') }}
          }
          @case ('nerve') {
            <strong>{{ brief.laggard.symbol }}</strong> {{ lang.t('homeNerveA') }}
            <span [class.up]="brief.laggard.changePct >= 0" [class.down]="brief.laggard.changePct < 0">{{ pct(brief.laggard.changePct) }}</span>.
            {{ lang.t('homeNerveB') }}
          }
        }
      </p>
      <div class="ai-actions">
        <button type="button" class="btn ghost" (click)="nextRead()">{{ lang.t('homeAnother') }}</button>
        @if (auth.signedIn()) {
          <a class="btn deposit" routerLink="/portfolio">{{ lang.t('homeDeposit') }}</a>
        } @else {
          <a class="btn deposit" routerLink="/signin">{{ lang.t('homeDeposit') }}</a>
        }
      </div>
    } @else {
      <p class="kicker">{{ lang.t('homeLiveRead') }}</p>
      <p class="ai-line">{{ lang.t('homeWait') }}</p>
    }
    <button type="button" class="btn ghost" (click)="openDesk()">{{ lang.t('homeAsk') }}</button>
    <p class="fine">{{ lang.t('homeReadPrices') }}</p>
  </div>
</section>

<ul class="mantra">
  <li>{{ lang.t('homeM1') }}</li>
  <li>{{ lang.t('homeM2') }}</li>
  <li>{{ lang.t('homeM3') }}</li>
</ul>

<section class="principles reviews" id="clients">
  <div class="section-head">
    <p class="kicker">{{ lang.t('homeClients') }}</p>
    <h2>{{ lang.t('homeReviews') }}</h2>
  </div>
  <div class="review-stage" [class.paused]="reviewHold()" (mouseenter)="holdReviews(true)" (mouseleave)="holdReviews(false)" (focusin)="holdReviews(true)" (focusout)="holdReviews(false)">
    @for (review of reviews(); track review.name; let i = $index) {
      <article [class.on]="reviewIndex() === i" [attr.hidden]="reviewIndex() === i ? null : true">
        <div class="review-top">
          <span class="review-mark">{{ review.mark }}</span>
          <div>
            <strong>{{ review.name }}</strong>
            <em>{{ review.topic }}</em>
          </div>
          <span class="stars" [attr.aria-label]="lang.t('homeStars')">★★★★★</span>
        </div>
        <p>“{{ review.quote }}”</p>
      </article>
    }
    <div class="review-pages" role="tablist" aria-label="Client notes">
      @for (review of reviews(); track review.name; let i = $index) {
        <button type="button" role="tab" [class.on]="reviewIndex() === i" [attr.aria-selected]="reviewIndex() === i" [attr.aria-label]="review.name" (click)="showReview(i)">
          @for (run of [reviewRun()]; track run) {
            @if (reviewIndex() === i) {
              <i></i>
            }
          }
        </button>
      }
    </div>
  </div>
</section>

<section class="preview">
  <div class="section-head row">
    <div>
      <p class="kicker">{{ lang.t('homeMarkets') }}</p>
      <h2>{{ lang.t('homeShort') }}</h2>
    </div>
    <a routerLink="/markets" class="text-link">{{ lang.t('homeAll') }}</a>
  </div>
  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>{{ lang.t('homeThMarket') }}</th>
          <th>{{ lang.t('homeThSession') }}</th>
          <th class="num">{{ lang.t('homeThLast') }}</th>
          <th class="num">{{ lang.t('homeThChange') }}</th>
        </tr>
      </thead>
      <tbody>
        @for (quote of preview(); track quote.symbol) {
          <tr>
            <td>
              <a [routerLink]="['/trade', quote.symbol]" class="symbol-link">
                <strong>{{ quote.symbol }}</strong>
                <span>{{ quote.name }}</span>
              </a>
            </td>
            <td><app-sparkline [points]="quote.spark" [up]="quote.changePct >= 0" [width]="112" [height]="32" /></td>
            <td class="num">{{ price(quote.price, quote.precision) }}</td>
            <td class="num" [class.up]="quote.changePct >= 0" [class.down]="quote.changePct < 0">{{ pct(quote.changePct) }}</td>
          </tr>
        } @empty {
          <tr>
            <td colspan="4" class="empty">{{ lang.t('homeEmpty') }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</section>

<section class="steps" id="resources">
  <div class="section-head">
    <p class="kicker">{{ lang.t('homeFourK') }}</p>
    <h2>{{ lang.t('homeFourH') }}</h2>
  </div>
  <ol>
    <li>
      <strong>{{ lang.t('homeS1') }}</strong>
      <span>{{ lang.t('homeS1b') }}</span>
    </li>
    <li>
      <strong>{{ lang.t('homeS2') }}</strong>
      <span>{{ lang.t('homeS2b') }}</span>
    </li>
    <li>
      <strong>{{ lang.t('homeS3') }}</strong>
      <span>{{ lang.t('homeS3b') }}</span>
    </li>
    <li>
      <strong>{{ lang.t('homeS4') }}</strong>
      <span>{{ lang.t('homeS4b') }}</span>
    </li>
  </ol>
</section>

<section class="close">
  <div>
    <p class="kicker light">{{ lang.t('homeNow') }}</p>
    <h2>{{ lang.t('homeCloseH') }} <em>{{ lang.t('homeCloseEm') }}</em></h2>
    <p>{{ lang.t('homeCloseP') }}</p>
  </div>
  @if (auth.signedIn()) {
    <a class="btn deposit" routerLink="/portfolio">{{ lang.t('homeDeposit') }}</a>
  } @else {
    <a class="btn deposit" routerLink="/signin">{{ lang.t('homeDeposit') }}</a>
  }
</section>

<section class="partners" [attr.aria-label]="lang.t('homePartners')">
  <p class="partners-label">{{ lang.t('homePartners') }}</p>
  <div class="partners-tape">
    <div class="partners-track">
      @for (brand of partnerMarks; track $index) {
          <span class="partner">
            @switch (brand) {
              @case ('jupiter') {
                <svg viewBox="0 0 32 32" aria-hidden="true"><circle cx="16" cy="16" r="7" /><path d="M4 20c3.2-1.4 6.2-4.6 12-4.6S24.8 18.6 28 20" /></svg>
                <strong>Jupiter</strong>
              }
              @case ('tradingview') {
                <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M6 22V10h4.2L16 20.2 21.8 10H26v12h-3.4v-6.6L18.2 22h-4.4l-4.4-6.6V22z" /></svg>
                <strong>TradingView</strong>
              }
              @case ('trust') {
                <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M16 4 7 7.4v7.2c0 5.6 3.6 9.4 9 11.4 5.4-2 9-5.8 9-11.4V7.4z" /></svg>
                <strong>Trust Wallet</strong>
              }
            }
          </span>
      }
    </div>
  </div>
</section>
</div>
